import { render, staticRenderFns } from "./Land.vue?vue&type=template&id=6f1e1af4"
import script from "./Land.vue?vue&type=script&lang=js"
export * from "./Land.vue?vue&type=script&lang=js"
import style0 from "./Land.vue?vue&type=style&index=0&id=6f1e1af4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports